// @core/api/endpoints/team/list_team_roles.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamRolesResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List team roles
 * Returns all roles defined for a team including built-in and custom roles with their associated permissions.
 */
export async function ListTeamRoles(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamRolesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTeamRolesResponse>(requestPath, { ...requestOptions, params });
}
